import * as _ from 'underscore';
const moment = require('pdc-platform-moment');

//LL: Used
export function getMinDate(): string {
    return moment().startOf('year').subtract(20, 'year').format('YYYY-MM-DD');
}

//LL: Used
export function getMaxDate(): string {
    return moment().startOf('year').add(10, 'year').format('YYYY-MM-DD');
}

// -------------------- DST ------------------

//LL: DST
export function get_dstDays_forYear_fromTheme(year: number, themeValue: any) {
    // let dstFromTheme = theme[themeFields.dst_switchingDays];   == themeValue   is array
    let find = _.find<any>(themeValue, (obj: any) => {
        return obj.year == year;
    });

    if (find != null) {
        return {
            toSummer: {
                toSummer: true,
                hourFrom: find.toSummerHourFrom,
                hourTo: find.toSummerHourTo,
                dateU: new Date(find.toSummerDate) //LL: string or Date   UTC ???
            },
            toWinter: {
                toSummer: false,
                hourFrom: find.toWinterHourFrom,
                hourTo: find.toWinterHourTo,
                dateU: new Date(find.toWinterDate) //LL: string or Date
            }
        };
    } else {
        return null;
    }
}

//LL: DST
export function is_dstDay_fromTheme(startDate: Moment, themeValue: any) {
    let isDST_toSummer = false;
    let isDST_toWinter = false;

    let yS = startDate.year();
    let mS = startDate.month();
    let dS = startDate.date();
    let dstDays1 = get_dstDays_forYear_fromTheme(yS, themeValue);
    if (dstDays1 != null) {
        let ySum = dstDays1.toSummer.dateU.getFullYear();
        let mSum = dstDays1.toSummer.dateU.getMonth();
        let dSum = dstDays1.toSummer.dateU.getDate();
        if (yS === ySum && mS === mSum && dS === dSum) {
            isDST_toSummer = true;
        }
        let yWin = dstDays1.toWinter.dateU.getFullYear();
        let mWin = dstDays1.toWinter.dateU.getMonth();
        let dWin = dstDays1.toWinter.dateU.getDate();
        if (yS === yWin && mS === mWin && dS === dWin) {
            isDST_toWinter = true;
        }
    }
    return { isDST_toSummer: isDST_toSummer, isDST_toWinter: isDST_toWinter };
}

//LL: DST
export function is_dstDaysInPeriod_fromTheme(nDays: number, startDate: Moment, endDate: Moment, themeValue: any) {
    let has = false;
    let nToSummer = 0;
    let nToWinter = 0;
    let days = [];
    for (let d = startDate.clone(), i = 0; i < nDays && d.isBefore(endDate); d.add(1, 'days'), i++) {
        let is_dstDay_Obj = is_dstDay_fromTheme(d, themeValue);
        let isDST_toSummer = is_dstDay_Obj.isDST_toSummer;
        let isDST_toWinter = is_dstDay_Obj.isDST_toWinter;
        if (isDST_toSummer || isDST_toWinter) {
            has = true;
            if (isDST_toSummer) {
                nToSummer++;
            }
            if (isDST_toWinter) {
                nToWinter++;
            }
            days.push({ day: d.clone(), iDay: i, isDST_toSummer: isDST_toSummer, isDST_toWinter: isDST_toWinter });
        }
    }
    return { has: has, nToSummer: nToSummer, nToWinter: nToWinter, days: days };
}

//LL: DST
export function calc_dstSwitchDay(curDate: Moment, tz: string) {
    // tz = 'Europe/Copenhagen'
    let isDST_toSummer = false;
    let isDST_toWinter = false;

    //let mCur = moment.tz("2022-03-27 03:34:56", tz);

    let mCur1 = moment.tz(curDate, tz);
    let curYear = curDate.year();
    let curMonth = curDate.month();
    let curDay = curDate.date();
    let mCur = moment.tz([curYear, curMonth, curDay, 0, 0, 0, 0], tz);

    // startOf: Mutates (!!!) the original moment by setting it to the start of a unit of time.
    let mCurStart = mCur.clone().startOf('day');
    let mCurEnd = mCur.clone().endOf('day');

    let f61 = mCur.format();
    let f64 = mCurStart.format(); // 2022-03-27T00:00:00+01:00  see +01
    let isDST_start = mCurStart.isDST(); // false
    let f66 = mCurEnd.format(); // 2022-03-27T23:59:59+02:00   see +02
    let isDST_end = mCurEnd.isDST(); // true

    if (isDST_start === isDST_end) {
        //return {isDST_toSummer: isDST_toSummer, isDST_toWinter: isDST_toWinter};
        return null;
    }

    isDST_toSummer = !isDST_start && isDST_end;
    isDST_toWinter = isDST_start && !isDST_end;

    //  add: Mutates (!!!) the original moment by adding time.

    let mDST, mPrev;
    let h, hPrev;
    for (let d = mCurStart.clone(), i = 0; d.isBefore(mCurEnd); d.add(1, 'hours'), i++) {
        let dst = d.isDST();
        if (dst !== isDST_start) {
            mDST = d.clone();
            h = i;
            break;
        } else {
            mPrev = d.clone();
            hPrev = i;
        }
    }
    let f68 = mDST.format();
    let f69 = mPrev.format();

    let hFrom;
    if (mPrev != null) {
        hFrom = mPrev.hour();
    }
    let hTo;
    if (mDST != null) {
        hTo = mDST.hour();
    }
    //LL: need: h, hTo

    let dstDays: any = {};
    if (isDST_toSummer) {
        dstDays.toSummer = {
            toSummer: true,
            dateU: new Date(Date.UTC(curYear, curMonth - 1, curDay, 0, 0, 0)),
            hourFrom: h,
            hourTo: hTo
        };
    }
    if (isDST_toWinter) {
        dstDays.toWinter = {
            toSummer: false,
            dateU: new Date(Date.UTC(curYear, curMonth - 1, curDay, 0, 0, 0)),
            hourFrom: h,
            hourTo: hTo
        };
    }

    return { isDST_toSummer: isDST_toSummer, isDST_toWinter: isDST_toWinter, hFrom: h, hTo: hTo, dstDays: dstDays };
}

//LL: DST
export function calc_dstSwitchDay_defaultTZ(curDate: Moment) {
    // tz = 'Browser default'
    let isDST_toSummer = false;
    let isDST_toWinter = false;

    let curYear = curDate.year();
    let curMonth = curDate.month();
    let curDay = curDate.date();
    let mCur = moment([curYear, curMonth, curDay, 0, 0, 0, 0]);

    // startOf: Mutates (!!!) the original moment by setting it to the start of a unit of time.
    let mCurStart = mCur.clone().startOf('day');
    let mCurEnd = mCur.clone().endOf('day');

    let f61 = mCur.format();
    let f64 = mCurStart.format(); // 2022-03-27T00:00:00+01:00  see +01
    let isDST_start = mCurStart.isDST(); // false
    let f66 = mCurEnd.format(); // 2022-03-27T23:59:59+02:00   see +02
    let isDST_end = mCurEnd.isDST(); // true

    if (isDST_start === isDST_end) {
        return null;
    }

    isDST_toSummer = !isDST_start && isDST_end;
    isDST_toWinter = isDST_start && !isDST_end;

    //  add: Mutates (!!!) the original moment by adding time.

    let mDST, mPrev;
    let h, hPrev;
    for (let d = mCurStart.clone(), i = 0; d.isBefore(mCurEnd); d.add(1, 'hours'), i++) {
        let dst = d.isDST();
        if (dst !== isDST_start) {
            mDST = d.clone();
            h = i;
            break;
        } else {
            mPrev = d.clone();
            hPrev = i;
        }
    }
    let f68 = mDST.format();
    let f69 = mPrev.format();

    let hFrom;
    if (mPrev != null) {
        hFrom = mPrev.hour();
    }
    let hTo;
    if (mDST != null) {
        hTo = mDST.hour();
    }
    //LL: need: h, hTo

    let dstDays: any = {};
    if (isDST_toSummer) {
        dstDays.toSummer = {
            toSummer: true,
            dateU: new Date(Date.UTC(curYear, curMonth - 1, curDay, 0, 0, 0)),
            hourFrom: h,
            hourTo: hTo
        };
    }
    if (isDST_toWinter) {
        dstDays.toWinter = {
            toSummer: false,
            dateU: new Date(Date.UTC(curYear, curMonth - 1, curDay, 0, 0, 0)),
            hourFrom: h,
            hourTo: hTo
        };
    }

    return { isDST_toSummer: isDST_toSummer, isDST_toWinter: isDST_toWinter, hFrom: h, hTo: hTo, dstDays: dstDays };
}

//LL: DST   tz == null => default TZ
export function is_dstDaysInPeriod_calculate(nDays: number, startDate: Moment, endDate: Moment, tz: string) {
    let has = false;
    let nToSummer = 0;
    let nToWinter = 0;
    let days = [];
    for (let d = startDate.clone(), i = 0; i < nDays && d.isBefore(endDate); d.add(1, 'days'), i++) {
        let is_dstDay_Obj = tz != null ? calc_dstSwitchDay(d, tz) : calc_dstSwitchDay_defaultTZ(d);
        if (is_dstDay_Obj != null) {
            let isDST_toSummer = is_dstDay_Obj.isDST_toSummer;
            let isDST_toWinter = is_dstDay_Obj.isDST_toWinter;
            if (isDST_toSummer || isDST_toWinter) {
                has = true;
                if (isDST_toSummer) {
                    nToSummer++;
                }
                if (isDST_toWinter) {
                    nToWinter++;
                }
                days.push({ day: d.clone(), iDay: i, isDST_toSummer: isDST_toSummer, isDST_toWinter: isDST_toWinter });
            }
        }
    }
    return { has: has, nToSummer: nToSummer, nToWinter: nToWinter, days: days };
}
